module.exports = __webpack_public_path__ + "public/img/blue_car.09d41f32.png";